import React from "react";
import { FirebaseUser } from "../type";

export const AuthContext = React.createContext<FirebaseUser | null | undefined>(
  undefined
);
